import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 'bold',
    },
    desc: {
        marginTop: '10px',
        marginBottom: '10px'
    },
    example: {
        fontWeight: 'bold',
        marginBottom: '10px'
    },
    highlight: {
        color: '#009EFF',
        fontWeight: 'bold',
        fontSize: '25px'
    }
}))

const getDeMinimisData = (lang) => {
    const classes = useStyles()

    const trans = (contentTh, contentEn) => {
        if (lang === 'en') return contentEn
        return contentTh
    }

    return {
        Afghaniatan: {
            title: 'Afghaniatan',
            flag: <span className="fi fi-af"></span>,
            content: trans(
                <>
                    <div className={classes.title}>Afghaniatan</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 5,000 AFN ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div className={classes.example}>
                        ตัวอย่าง เช่น หากมูลค่าสำแดงของสินค้าของคุณ คือ 5,000 AFN เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 1,000.00 AFN ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>25 AFN</span> คิดเป็นเงินไทย <span className={classes.highlight}>2,011.25 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Afghaniatan</div>
                    <div>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 5,000 AFN ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div className={classes.example}>
                        ตัวอย่าง เช่น หากมูลค่าสำแดงของสินค้าของคุณ คือ 5,000 AFN เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 1,000.00 AFN ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>25 AFN</span> คิดเป็นเงินไทย <span className={classes.highlight}>2,011.25 บาท</span>
                    </div>
                </>
            )
        },
        Argentina: {
            title: 'Argentina',
            flag: <span className="fi fi-ar"></span>,
            content: trans(
                <>
                    <div className={classes.title}>Argentina</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>25 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>800 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Argentina</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>25 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>800 บาท</span>
                    </div>
                </>
            )
        },
        Albania: {
            title: 'Albania',
            flag: <span className="fi fi-al"></span>,
            content: trans(
                <>
                    <div className={classes.title}>Albania</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 22 ยูโร ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 22 ยูโร เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 3.30 ยูโรให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 EUR</span> คิดเป็นเงินไทย <span className={classes.highlight}>837 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Albania</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 22 ยูโร ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 22 ยูโร เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 3.30 ยูโรให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 EUR</span> คิดเป็นเงินไทย <span className={classes.highlight}>837 บาท</span>
                    </div>
                </>
            )
        },
        Algeria: {
            title: 'Algeria',
            flag: <span className="fi fi-dz"></span>,
            content: (
                <>
                    <div className={classes.title}>Algeria</div>
                    <div className={classes.example}>
                    ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 19.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>19 % จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Algeria</div>
                    <div className={classes.example}>
                    ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 19.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>19 % จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Angola: {
            title: 'Angola',
            flag: <span className="fi fi-ao"></span>,
            content: (
                <>
                    <div className={classes.title}>Angola</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดการส่งจะอยู่ที่ 17 %
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 19.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,479 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Angola</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดการส่งจะอยู่ที่ 17 %
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 19.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,479 บาท</span>
                    </div>
                </>
            )
        },
        'Antigua and Barbuda': {
            title: 'Antigua and Barbuda',
            flag: <span className="fi fi-ag"></span>,
            content: trans(
                <>
                    <div className={classes.title}>Antigua and Barbuda</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15 % จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Antigua and Barbuda</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15 % จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Armenia: {
            title: 'Armenia',
            flag: <span className='fi fi-am'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Armenia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150,000 อามาเนียดรัมส์</span> คิดเป็นเงินไทย <span className={classes.highlight}>10,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Armenia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150,000 อามาเนียดรัมส์</span> คิดเป็นเงินไทย <span className={classes.highlight}>10,000 บาท</span>
                    </div>
                </>
            )
        },
        Australia: {
            title: 'Australia',
            flag: <span className='fi fi-au'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Australia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1000 ดอลล่าร์ออสเตรเลีย</span> คิดเป็นเงินไทย <span className={classes.highlight}>25,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Australia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1000 ดอลล่าร์ออสเตรเลีย</span> คิดเป็นเงินไทย <span className={classes.highlight}>25,000 บาท</span>
                    </div>
                </>
            )
        },
        Austria: {
            title: 'Austria',
            flag: <span className='fi fi-at'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Austria</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Austria</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Azerbaijan: {
            title: 'Azerbaijan',
            flag: <span className='fi fi-az'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Azerbaijan</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 50 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18 %
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 50 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 9.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,740 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Austria</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 50 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18 %
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 50 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 9.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,740 บาท</span>
                    </div>
                </>
            )
        },
        Andorra: {
            title: 'Andorra',
            flag: <span className='fi fi-ad'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Andorra</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>450 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Andorra</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>450 บาท</span>
                    </div>
                </>
            )
        },
        Bahamas: {
            title: 'Bahamas',
            flag: <span className='fi fi-bs'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Bahamas</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 7.50 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>7.5% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Bahamas</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 7.50 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>7.5% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Bahrain: {
            title: 'Bahrain',
            flag: <span className='fi fi-bh'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Bahrain</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Bahrain</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        Belarus: {
            title: 'Belarus',
            flag: <span className='fi fi-by'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Belarus</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Belarus</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>400 บาท</span>
                    </div>
                </>
            )
        },
        Bangladesh: {
            title: 'Bangladesh',
            flag: <span className='fi fi-bd'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Bangladesh</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 ทาคา</span> คิดเป็นเงินไทย <span className={classes.highlight}>400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Bangladesh</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 ทาคา</span> คิดเป็นเงินไทย <span className={classes.highlight}>400 บาท</span>
                    </div>
                </>
            )
        },
        Barbados: {
            title: 'Barbados',
            flag: <span className='fi fi-bb'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Barbados</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 17.50 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>17.5% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Barbados</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 17.50 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>17.5% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Belgium: {
            title: 'Belgium',
            flag: <span className='fi fi-be'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Belgium</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Belgium</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Belize: {
            title: 'Belize',
            flag: <span className='fi fi-bz'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Belize</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12.50 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12.5% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Belize</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12.50 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12.5% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Benin: {
            title: 'Benin',
            flag: <span className='fi fi-bj'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Benin</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 50 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 50 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 9.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,741 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Benin</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 50 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 50 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 9.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,741 บาท</span>
                    </div>
                </>
            )
        },
        Bhutan: {
            title: 'Bhutan',
            flag: <span className='fi fi-bt'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Bhutan</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 50.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Bhutan</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 50.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Bolivia: {
            title: 'Bolivia',
            flag: <span className='fi fi-bo'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Bolivia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 1,000 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 14.9%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>34,810 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Bolivia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 1,000 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 14.9%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>34,810 บาท</span>
                    </div>
                </>
            )
        },
        'Bosnia and herzegovina': {
            title: 'Bosnia and herzegovina',
            flag: <span className='fi fi-ba'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Bosnia and herzegovina</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 17.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>17% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Bosnia and herzegovina</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 17.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>17% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Botswana: {
            title: 'Botswana',
            flag: <span className='fi fi-bw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Botswana</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 12% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Botswana</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 12% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Brazil: {
            title: 'Brazil',
            flag: <span className='fi fi-br'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Brazil</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 37.53% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,300 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Brazil</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 37.53% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,300 บาท</span>
                    </div>
                </>
            )
        },
        Brunei: {
            title: 'Brunei',
            flag: <span className='fi fi-bn'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Brunei</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Brunei</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        Bulgaria: {
            title: 'Bulgaria',
            flag: <span className='fi fi-bg'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Bulgaria</div>,
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนดังกล่าว และ 15 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 15 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Bulgaria</div>,
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนดังกล่าว และ 15 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 15 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,400 บาท</span>
                    </div>
                </>
            )
        },
        'Burkina Faso': {
            title: 'Burkina Faso',
            flag: <span className='fi fi-bf'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Burkina Faso</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Burkina Faso</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>
            )
        },
        Burundi: {
            title: 'Burundi',
            flag: <span className='fi fi-bi'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Burundi</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 บรูเนียนดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Burundi</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 บรูเนียนดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,700 บาท</span>
                    </div>
                </>
            )
        },
        Cambodia: {
            title: 'Cambodia',
            flag: <span className='fi fi-kh'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Cambodia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Cambodia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>
            )
        },
        Cameroon: {
            title: 'Cameroon',
            flag: <span className='fi fi-cm'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Cameroon</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 400 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 19.3%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>13,924 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Cameroon</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 400 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 19.3%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>13,924 บาท</span>
                    </div>
                </>
            )
        },
        Canada: {
            title: 'Canada',
            flag: <span className='fi fi-ca'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Canada</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>500 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Canada</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>500 บาท</span>
                    </div>
                </>
            )
        },
        'Cabo verde': {
            title: 'Cabo verde',
            flag: <span className='fi fi-cv'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Cabo verde</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Cabo verde</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Chad: {
            title: 'Chad',
            flag: <span className='fi fi-td'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Chad</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>697.17 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Chad</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>697.17 บาท</span>
                    </div>
                </>
            )
        },
        Chile: {
            title: 'Chile',
            flag: <span className='fi fi-cl'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Chile</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>30 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Chile</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>30 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,000 บาท</span>
                    </div>
                </>
            )
        },
        China: {
            title: 'China',
            flag: <span className='fi fi-cn'></span>,
            content: trans(
                <>
                    <div className={classes.title}>China</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>30 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Chile</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 หยวน</span> คิดเป็นเงินไทย <span className={classes.highlight}>300 บาท</span>
                    </div>
                </>
            )
        },
        Colombia: {
            title: 'Colombia',
            flag:  <span className='fi fi-co'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Colombia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Colombia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,700 บาท</span>
                    </div>
                </>
            )
        },
        Comoros: {
            title: 'Comoros',
            flag: <span className='fi fi-km'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Comoros</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการจัดส่งจะเป็น 10% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 10.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Comoros</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการจัดส่งจะเป็น 10% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 10.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Congo: {
            title: 'Congo',
            flag: <span className='fi fi-cd'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Congo</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,486 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Congo</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,486 บาท</span>
                    </div>
                </>
            )
        },
        'Congo Republic': {
            title: 'Congo Republic',
            flag: <span className='fi fi-cg'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Congo Republic</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,486 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Congo Republic</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,486 บาท</span>
                    </div>
                </>
            )
        },
        'Costa Rica': {
            title: 'Costa Rica',
            flag: <span className='fi fi-cr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Costa Rica</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 13.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>13% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Costa Rica</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 13.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>13% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        'Cote D\'lvoire': {
            title: "Cote D\'lvoire",
            flag: <span className='fi fi-ci'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Cote D'lvoire</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>697 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Cote D'lvoire</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>697 บาท</span>
                    </div>
                </>
            )
        },
        Croatia: {
            title: 'Croatia',
            flag: <span className='fi fi-hr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Croatia</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร </span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Croatia</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร </span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Cuba: {
            title: 'Cuba',
            flag: <span className='fi fi-cu'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Cuba</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 CAD ภาษีนำเข้าสำหรับการขนส่งจะอยู่ที่ 5%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลลาร์แคนาดา</span> คิดเป็นเงินไทย <span className={classes.highlight}>521 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Cuba</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 CAD ภาษีนำเข้าสำหรับการขนส่งจะอยู่ที่ 5%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลลาร์แคนาดา</span> คิดเป็นเงินไทย <span className={classes.highlight}>521 บาท</span>
                    </div>
                </>
            )
        },
        Cyprus: {
            title: 'Cyprus',
            flag: <span className='fi fi-cy'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Cyprus</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 17 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 17 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,500 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Cyprus</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 17 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 17 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,500 บาท</span>
                    </div>
                </>
            )
        },
        'Czech Republic': {
            title: 'Czech Republic',
            flag: <span className='fi fi-cz'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Czech Republic</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>21% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Czech</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>21% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Denmark: {
            title: 'Denmark',
            flag: <span className='fi fi-dk'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Denmark</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Denmark</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Djibouti: {
            title: 'Djibouti',
            flag: <span className='fi fi-dj'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Djibouti</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 33.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>33% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Djibouti</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 33.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>33% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        'Dominican Republic': {
            title: 'Dominican Republic',
            flag: <span className='fi fi-do'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Dominican Republic</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Dominican Republic</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,700 บาท</span>
                    </div>
                </>
            )
        },
        Dominica: {
            title: 'Dominica',
            flag: <span className='fi fi-dm'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Dominica</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Dominica</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Ecuador: {
            title: 'Ecuador',
            flag: <span className='fi fi-ec'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Ecuador</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 10 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 12%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>349 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Ecuador</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 10 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 12%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>349 บาท</span>
                    </div>
                </>
            )
        },
        Egypt: {
            title: 'Egypt',
            flag: <span className='fi fi-eg'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Egypt</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 14.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>14% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Egypt</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 14.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>14% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        'El Salvador': {
            title: 'El Salvador',
            flag: <span className='fi fi-sv'></span>,
            conten: trans(
                <>
                    <div className={classes.title}>El Salvador</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 13.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>13% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Eritrea: {
            title: 'Eritrea',
            flag: <span className='fi fi-er'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Eritrea</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 4%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,485.85 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Eritrea</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 4%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,485.85 บาท</span>
                    </div>
                </>
            )
        },
        Estonia: {
            title: 'Estonia',
            flag: <span className='fi fi-ee'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Estonia</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ยูโร เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 ยูโรให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Estonia</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ยูโร เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 ยูโรให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Eswatini: {
            title: 'Eswatini',
            flag: <span className='fi fi-sz'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Eswatini</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 14.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>14% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Eswatini</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 14.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>14% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Ethiopia: {
            title: 'Ethiopia',
            flag: <span className='fi fi-et'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Ethiopia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>770 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Ethiopia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>770 บาท</span>
                    </div>
                </>
            )
        },
        Faroe: {
            title: 'Faroe',
            flag: <span className='fi fi-fo'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Faroe</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Faroe</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Fiji: {
            title: 'Fiji',
            flag: <span className='fi fi-fj'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Fiji</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 200 FJD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 ดอลลาร์ฟิจิ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,134 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Fiji</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 200 FJD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 ดอลลาร์ฟิจิ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,134 บาท</span>
                    </div>
                </>
            )
        },
        Finland: {
            title: 'Finland',
            flag: <span className='fi fi-fi'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Finland</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Finland</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        France: {
            title: 'France',
            flag: <span className='fi fi-fr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>France</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>France</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Gabon: {
            title: 'Gabon',
            flag: <span className='fi fi-ga'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Gabon</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>349 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Gabon</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>349 บาท</span>
                    </div>
                </>
            )
        },
        Gambia: {
            title: 'Gambia',
            flag: <span className='fi fi-gm'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Gambia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,488 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Gambia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,488 บาท</span>
                    </div>
                </>
            )
        },
        Georgia: {
            title: 'Georgia',
            flag: <span className='fi fi-ge'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Georgia</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 18.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>18% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Georgia</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 18.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>18% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Germany: {
            title: 'Germany',
            flag: <span className='fi fi-de'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Germany</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Germany</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Ghana: {
            title: 'Ghana',
            flag: <span className='fi fi-gh'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Ghana</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 5 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>174 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Ghana</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 5 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>174 บาท</span>
                    </div>
                </>
            )
        },
        Greece: {
            title: 'Greece',
            flag: <span className='fi fi-gr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Greece</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Greece</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Greenland: {
            title: 'Greenland',
            flag: <span className='fi fi-gl'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Greenland</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Greenland</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Grenada: {
            title: 'Grenada',
            flag: <span className='fi fi-gd'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Grenada</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Grenada</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Guatemala: {
            title: 'Guatemala',
            flag: <span className='fi fi-gt'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Guatemala</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Guatemala</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Guinea: {
            title: 'Guinea',
            flag: <span className='fi fi-gn'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Guinea</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 15 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>523 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Guinea</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 15 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>523 บาท</span>
                    </div>
                </>
            )
        },
        Guyana: {
            title: 'Guyana',
            flag: <span className='fi fi-gy'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Guyana</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 14%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,488 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Guyana</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 100 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 14%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,488 บาท</span>
                    </div>
                </>
            )
        },
        Haiti: {
            title: 'Haiti',
            flag: <span className='fi fi-ht'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Haiti</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 10.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>110% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Haiti</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 10.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>110% จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Honduras: {
            title: 'Honduras',
            flag: <span className='fi fi-hn'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Honduras</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 30 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>30 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,044 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Honduras</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 30 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>30 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,044 บาท</span>
                    </div>
                </>
            )
        },
        'Hong Kong': {
            title: 'Hong Kong',
            flag: <span className='fi fi-hk'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Hong Kong</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Hong Kong</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        Hungary: {
            title: 'Hungary',
            flag: <span className='fi fi-hu'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Hungary</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Hungary</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Iceland: {
            title: 'Iceland',
            flag: <span className='fi fi-is'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Iceland</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 โครน่า</span> คิดเป็นเงินไทย <span className={classes.highlight}>300 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Iceland</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 โครน่า</span> คิดเป็นเงินไทย <span className={classes.highlight}>300 บาท</span>
                    </div>
                </>
            )
        },
        India: {
            title: 'India',
            flag: <span className='fi fi-in'></span>,
            content: trans(
                <>
                    <div className={classes.title}>India</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10,000 รูปี</span> คิดเป็นเงินไทย <span className={classes.highlight}>5,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>India</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10,000 รูปี</span> คิดเป็นเงินไทย <span className={classes.highlight}>5,000 บาท</span>
                    </div>
                </>
            )
        },
        Indonesia: {
            title: 'Indonesia',
            flag: <span className='fi fi-id'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Indonesia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Indonesia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>
            )
        },
        Iran: {
            title: 'Iran',
            flag: <span className='fi fi-ir'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Iran</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Iran</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>
            )
        },
        Ireland: {
            title: 'Ireland',
            flag: <span className='fi fi-ie'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Ireland</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Ireland</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Israel: {
            title: 'Israel',
            flag: <span className='fi fi-il'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Israel</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Israel</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>
            )
        },
        Italy: {
            title: 'Italy',
            flag: <span className='fi fi-it'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Italy</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Italy</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Jamaica: {
            title: 'Jamaica',
            flag: <span className='fi fi-jm'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Jamaica</div>
                    <div className={classes.desc}>
                        หากมูลค่ามากกว่า 50 ดอลล่าร์สหรัฐ เสียภาษีนำเข้า16.5% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,750 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Jamaica</div>
                    <div className={classes.desc}>
                        หากมูลค่ามากกว่า 50 ดอลล่าร์สหรัฐ เสียภาษีนำเข้า16.5% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,750 บาท</span>
                    </div>
                </>
            )
        },
        Japan: {
            title: 'Japan',
            flag: <span className='fi fi-jp'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Japan</div>
                    <div className={classes.desc}>
                        หากมูลค่ามากกว่า 10,000 เยน เสียภาษีนำเข้า 10% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10,000 เยน</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Japan</div>
                    <div className={classes.desc}>
                        หากมูลค่ามากกว่า 10,000 เยน เสียภาษีนำเข้า 10% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10,000 เยน</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,000 บาท</span>
                    </div>
                </>
            )
        },
        Jordan: {
            title: 'Jordan',
            flag: <span className='fi fi-jo'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Jordan</div>
                    <div className={classes.desc}>
                        หากมูลค่ามากกว่า 20 ดอลล่าร์สหรัฐ เสียภาษีนำเข้า 16% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Jordan</div>
                    <div className={classes.desc}>
                        หากมูลค่ามากกว่า 20 ดอลล่าร์สหรัฐ เสียภาษีนำเข้า 16% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>
            )
        },
        Kazakhstan: {
            title: 'Kazakhstan',
            flag: <span className='fi fi-kz'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Kazakhstan</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Kazakhstan</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 12 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Kenya: {
            title: 'Kenya',
            flag: <span className='fi fi-ke'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Kenya</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 16 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>16% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Kenya</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 16 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>16% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Kiribati: {
            title: 'Kiribati',
            flag: <span className='fi fi-ki'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Kiribati</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Kiribati</div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Kuwait: {
            title: 'Kuwait',
            flag: <span className='fi fi-kw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Kuwait</div>
                    <div className={classes.example}>
                        ไม่มีการเสียภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Kuwait</div>
                    <div className={classes.example}>
                        ไม่มีการเสียภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        Kyrgyzstan: {
            title: 'Kyrgyzstan',
            flag: <span className='fi fi-kg'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Kyrgyzstan</div>
                    <div className={classes.desc}>
                       หากมูลค่ามากกว่า 1,000  ยูโร เสียภาษีนำเข้า12% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>38,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Kyrgyzstan</div>
                    <div className={classes.desc}>
                       หากมูลค่ามากกว่า 1,000  ยูโร เสียภาษีนำเข้า12% ของมูลค่าจริงสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>38,000 บาท</span>
                    </div>
                </>
            )
        },
        Laos: {
            title: 'Laos',
            flag: <span className='fi fi-la'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Laos</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 10 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Laos</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 10 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Latvia: {
            title: 'Latvia',
            flag: <span className='fi fi-lv'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Latvia</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>146 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Latvia</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>146 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Lebanon: {
            title: 'Lebanon',
            flag: <span className='fi fi-lb'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Lebanon</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 11 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>11% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Lebanon</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 11 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>11% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Lesotho: {
            title: 'Lesotho',
            flag: <span className='fi fi-ls'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Lesotho</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Lesotho</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Liberia: {
            title: 'Liberia',
            flag: <span className='fi fi-lr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Liberia</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Liberia</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Liechtenstein: {
            title: 'Liechtenstein',
            flag: <span className='fi fi-li'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Liechtenstein</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 7.7 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>7.7% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Liechtenstein</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 7.7 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>7.7% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Lithuania: {
            title: 'Lithuania',
            flag: <span className='fi fi-lt'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Lithuania</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Lithuania</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Luxembourg: {
            title: 'Luxembourg',
            flag: <span className='fi fi-lu'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Luxembourg</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Luxembourg</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Macao: {
            title: 'Macao',
            flag: <span className='fi fi-mo'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Macao</div>
                    <div className={classes.example}>
                       ไม่มีการเสียภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Macao</div>
                    <div className={classes.example}>
                       ไม่มีการเสียภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        'Macedonia Republic': {
            title: 'Macedonia Republic',
            flag: <span className='fi fi-mk'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Macedonia Republic</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า22 EUR จะเสียภาษี 18%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>840 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Macedonia Republic</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า22 EUR จะเสียภาษี 18%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>840 บาท</span>
                    </div>
                </>
            )
        },
        Madagascar: {
            title: 'Madagascar',
            flag: <span className='fi fi-mg'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Madagascar</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า20 USD จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Madagascar</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า20 USD จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>
            )
        },
        Malawi: {
            title: 'Malawi',
            flag: <span className='fi fi-mw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Malawi</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 16.5 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>16.5% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Malawi</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 16.5 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>16.5%ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Malaysia: {
            title: 'Malaysia',
            flag: <span className='fi fi-my'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Malaysia</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 496 ริงกิต จะเสียภาษี 10%ของมูลค่าทั้งหมด
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 16.5 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>496 ริงกิต</span> คิดเป็นเงินไทย <span className={classes.highlight}>4,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Malaysia</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 496 ริงกิต จะเสียภาษี 10%ของมูลค่าทั้งหมด
                    </div>
                    <div className={classes.example}>
                        ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 16.5 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>496 ริงกิต</span> คิดเป็นเงินไทย <span className={classes.highlight}>4,000 บาท</span>
                    </div>
                </>
            )
        },
        Maldives: {
            title: 'Maldives',
            flag: <span className='fi fi-mv'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Maldives</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 6 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>6% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Maldives</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 6 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>6% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Mali: {
            title: 'Mali',
            flag: <span className='fi fi-ml'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Mali</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า20 USD จะเสียภาษี 18%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Mali</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า20 USD จะเสียภาษี 18%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>
            )
        },
        Malta: {
            title: 'Malta',
            flag: <span className='fi fi-mt'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Malta</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>148 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Malta</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>148 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Mauritania: {
            title: 'Mauritania',
            flag: <span className='fi fi-mr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Mauritania</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 18 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>18%ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Mauritania</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 18 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>18%ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Mauritius: {
            title: 'Mauritius',
            flag: <span className='fi fi-mu'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Mauritius</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า500 MUR  จะเสียภาษี 19%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>500 รูปีมอริเชียส</span> คิดเป็นเงินไทย <span className={classes.highlight}>385 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Mauritius</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า500 MUR  จะเสียภาษี 19%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>500 รูปีมอริเชียส</span> คิดเป็นเงินไทย <span className={classes.highlight}>385 บาท</span>
                    </div>
                </>
            )
        },
        Mexico: {
            title: 'Mexico',
            flag: <span className='fi fi-mx'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Mexico</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 50 ดอลล่าร์สหรัฐ  จะเสียภาษี 15%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Mexico</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 50 ดอลล่าร์สหรัฐ  จะเสียภาษี 15%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,700 บาท</span>
                    </div>
                </>
            )
        },
        Moldova: {
            title: 'Moldova',
            flag: <span className='fi fi-md'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Moldova</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Moldova</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Monaco: {
            title: 'Monaco',
            flag: <span className='fi fi-mc'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Monaco</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 19 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>19% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Monaco</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 19 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>19% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Montenegro: {
            title: 'Montenegro',
            flag: <span className='fi fi-me'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Montenegro</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Montenegro</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Morocco: {
            title: 'Morocco',
            flag: <span className='fi fi-ma'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Morocco</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 300 โมร็อกโค เดียร์แฮม จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>300 โมร็อกโค เดียร์แฮม</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Morocco</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 300 โมร็อกโค เดียร์แฮม จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>300 โมร็อกโค เดียร์แฮม</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,000 บาท</span>
                    </div>
                </>
            )
        },
        Myanmar: {
            title: 'Myanmar',
            flag: <span className='fi fi-mm'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Myanmar</div>
                    <div className={classes.example}>
                       ไม่มีภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Myanmar</div>
                    <div className={classes.example}>
                       ไม่มีภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        Namibia: {
            title: 'Namibia',
            flag: <span className='fi fi-na'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Namibia</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 13 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>13% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Namibia</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 13 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>13% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Nepal: {
            title: 'Nepal',
            flag: <span className='fi fi-np'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Nepal</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Nepal</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        Netherlands: {
            title: 'Netherlands',
            flag: <span className='fi fi-nl'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Netherlands</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Netherlands</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Aruba: {
            title: 'Aruba',
            flag: <span className='fi fi-aw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Aruba</div>
                    <div className={classes.desc}>
                       หากมูลค่าเต็มของสินค้าของคุณมากกว่า 10 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20 %
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>696 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Aruba</div>
                    <div className={classes.desc}>
                       หากมูลค่าเต็มของสินค้าของคุณมากกว่า 10 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20 %
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>696 บาท</span>
                    </div>
                </>
            )
        },
        Curacao: {
            title: 'Curacao',
            flag: <span className='fi fi-cw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Curacao</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 % จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Curacao</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 % จากมูลค่าเต็มของสินค้า</span>
                    </div>
                </>
            )
        },
        'Sint Maarten': {
            title: 'Sint Maarten',
            flag: <span className='fi fi-sx'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Sint Maarten</div>
                    <div className={classes.desc}>
                       หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 1.5%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>348 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Sint Maarten</div>
                    <div className={classes.desc}>
                       หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 1.5%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>348 บาท</span>
                    </div>
                </>
            )
        },
        'New Zealand': {
            title: 'New Zealand',
            flag: <span className='fi fi-nz'></span>,
            content: trans(
                <>
                    <div className={classes.title}>New Zealand</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 400 นิวซีแลนด์ดอลล่าร์ จะเสียภาษี 15%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 นิวซีแลนด์ดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,200 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>New Zealand</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 400 นิวซีแลนด์ดอลล่าร์ จะเสียภาษี 15%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 นิวซีแลนด์ดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,200 บาท</span>
                    </div>
                </>
            )
        },
        Nicaragua: {
            title: 'Nicaragua',
            flag: <span className='fi fi-ni'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Nicaragua</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Nicaragua</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 15 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Nigeria: {
            title: 'Nigeria',
            flag: <span className='fi fi-ng'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Nigeria</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 10 USD จะเสียภาษี 5%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>350 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Nigeria</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 10 USD จะเสียภาษี 5%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>350 บาท</span>
                    </div>
                </>
            )
        },
        Niger: {
            title: 'Niger',
            flag: <span className='fi fi-ne'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Niger</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 20 USD จะเสียภาษี 18%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Niger</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 20 USD จะเสียภาษี 18%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>700 บาท</span>
                    </div>
                </>
            )
        },
        Norway: {
            title: 'Norway',
            flag: <span className='fi fi-no'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Norway</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 199 โครเนอร์ นอร์เวย์ จะเสียภาษี 25%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>199 โครเนอร์ นอร์เวย์</span> คิดเป็นเงินไทย <span className={classes.highlight}>800 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Norway</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 199 โครเนอร์ นอร์เวย์ จะเสียภาษี 25%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>199 โครเนอร์ นอร์เวย์</span> คิดเป็นเงินไทย <span className={classes.highlight}>800 บาท</span>
                    </div>
                </>
            )
        },
        Oman: {
            title: 'Oman',
            flag: <span className='fi fi-om'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Oman</div>
                    <div className={classes.example}>
                       ไม่มีการเสียภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Oman</div>
                    <div className={classes.example}>
                       ไม่มีการเสียภาษีนำเข้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        Pakistan: {
            title: 'Pakistan',
            flag: <span className='fi fi-pk'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Pakistan</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 17 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>17%ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Pakistan</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 17 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>17%ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Panama: {
            title: 'Panama',
            flag: <span className='fi fi-pa'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Panama</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 95 ดอลล่าร์สหรัฐ จะเสียภาษี 10%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>95 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Panama</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 95 ดอลล่าร์สหรัฐ จะเสียภาษี 10%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>95 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>
            )
        },
        'Papua New Guinea': {
            title: 'Papua New Guinea',
            flag: <span className='fi fi-pg'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Papua New Guinea</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 25 PGK จะเสียภาษี 10%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>25 PGK</span> คิดเป็นเงินไทย <span className={classes.highlight}>245 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Papua New Guinea</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 25 PGK จะเสียภาษี 10%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>25 PGK</span> คิดเป็นเงินไทย <span className={classes.highlight}>245 บาท</span>
                    </div>
                </>
            )
        },
        Paraguay: {
            title: 'Paraguay',
            flag: <span className='fi fi-py'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Paraguay</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 96 ดอลล่าร์สหรัฐ จะเสียภาษี 7%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>96 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Paraguay</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 96 ดอลล่าร์สหรัฐ จะเสียภาษี 7%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>96 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>
            )
        },
        Philippines: {
            title: 'Philippines',
            flag: <span className='fi fi-ph'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Philippines</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 196 ดอลล่าร์สหรัฐ จะเสียภาษี 12%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>196 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Philippines</div>
                    <div className={classes.desc}>
                       หากมูลค่าของสินค้ามากกว่า 196 ดอลล่าร์สหรัฐ จะเสียภาษี 12%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>196 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,700 บาท</span>
                    </div>
                </>
            )
        },
        Poland: {
            title: 'Poland',
            flag: <span className='fi fi-pl'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Poland</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>146 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Poland</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>146 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Portugal: {
            title: 'Portugal',
            flag: <span className='fi fi-pt'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Portugal</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>146 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Portugal</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>146 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Qatar: {
            title: 'Qatar',
            flag: <span className='fi fi-qa'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Qatar</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 5 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5% ของมูลค่าสินค้า</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Qatar</div>
                    <div className={classes.example}>
                       ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 ดอลล่าร์สหรัฐ เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 5 ดอลล่าร์สหรัฐ ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5% ของมูลค่าสินค้า</span>
                    </div>
                </>
            )
        },
        Romania: {
            title: 'Romania',
            flag: <span className='fi fi-ro'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Romania</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Romania</div>
                    <div className={classes.desc}>
                       ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Russia: {
            title: 'Russia',
            flag: <span className='fi fi-ru'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Russia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>7964 รัสเซียรูเบิล</span> คิดเป็นเงินไทย <span className={classes.highlight}>4,500 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Russia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>7964 รัสเซียรูเบิล</span> คิดเป็นเงินไทย <span className={classes.highlight}>4,500 บาท</span>
                    </div>
                </>
            )
        },
        Rwanda: {
            title: 'Rwanda',
            flag: <span className='fi fi-rw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Rwanda</div>
                    <div className={classes.desc}>
                        หากมูลค่าของสินค้ามากกว่า 200 USD จะเสียภาษี 18% ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,990 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Rwanda</div>
                    <div className={classes.desc}>
                        หากมูลค่าของสินค้ามากกว่า 200 USD จะเสียภาษี 18% ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>200 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,990 บาท</span>
                    </div>
                </>
            )
        },
        'Saint Christopher': {
            title: 'Saint Christopher',
            flag: <span className='fi fi-kh'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Saint Christopher</div>
                    <div className={classes.desc}>
                        -
                    </div>
                </>,
                <>
                    <div className={classes.title}>Saint Christopher</div>
                    <div className={classes.desc}>
                        -
                    </div>
                </>
            )
        },
        'Saint Lucia': {
            title: 'Saint Lucia',
            flag: <span className='fi fi-lc'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Saint Lucia</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Saint Lucia</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        'Saint Vincent and the Grenadines': {
            title: 'Saint Vincent and the Grenadines',
            flag: <span className='fi fi-vc'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Saint Vincent and the Grenadines</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Saint Vincent and the Grenadines</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Samoa: {
            title: 'Samoa',
            flag: <span className='fi fi-ws'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Samoa</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Samoa</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        'San Marino': {
            title: 'San Marino',
            flag: <span className='fi fi-sm'></span>,
            content: trans(
                <>
                    <div className={classes.title}>San Marino</div>
                    <div className={classes.desc}>
                        หากมูลค่าของสินค้ามากกว่า 22 USD จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 EUR</span> คิดเป็นเงินไทย <span className={classes.highlight}>845 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>San Marino</div>
                    <div className={classes.desc}>
                        หากมูลค่าของสินค้ามากกว่า 22 USD จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 EUR</span> คิดเป็นเงินไทย <span className={classes.highlight}>845 บาท</span>
                    </div>
                </>
            )
        },
        'Sao Tome and Principe': {
            title: 'Sao Tome and Principe',
            flag: <span className='fi fi-st'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Sao Tome and Principe</div>
                    <div className={classes.desc}>
                        อัตราภาษีภายนอกทั่วไป – ร้อยละ 5 สำหรับสินค้าประเภทที่หนึ่ง (เช่น สินค้าพื้นฐาน) ร้อยละ 10 สำหรับสินค้าประเภทที่สอง (เช่น วัตถุดิบ) ร้อยละ 20 สำหรับสินค้าประเภทที่สาม (เช่น สินค้าขั้นกลาง เช่น อาหารและเครื่องสำอางส่วนใหญ่) เครื่องดื่มแอลกอฮอล์ (เบียร์ ไวน์ และเครื่องดื่มสปิริต) จัดอยู่ในประเภทที่ 3 โดยมีอัตราภาษีร้อยละ 20 นอกจากนี้ ผลิตภัณฑ์เหล่านี้ยังมีค่าธรรมเนียมเพิ่มเติมที่แตกต่างกันระหว่าง 50 เปอร์เซ็นต์ 80 เปอร์เซ็นต์ และ 110 เปอร์เซ็นต์ ภาษีสำหรับเครื่องดื่มแอลกอฮอล์คิดตามลิตร (สุรา $1.4/ลิตร ไวน์ $0.47/ลิตร และเบียร์ $0.28/ลิตร)
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ขึ้นอยู่กับสินค้าแต่ละชนิด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Sao Tome and Principe</div>
                    <div className={classes.desc}>
                        อัตราภาษีภายนอกทั่วไป – ร้อยละ 5 สำหรับสินค้าประเภทที่หนึ่ง (เช่น สินค้าพื้นฐาน) ร้อยละ 10 สำหรับสินค้าประเภทที่สอง (เช่น วัตถุดิบ) ร้อยละ 20 สำหรับสินค้าประเภทที่สาม (เช่น สินค้าขั้นกลาง เช่น อาหารและเครื่องสำอางส่วนใหญ่) เครื่องดื่มแอลกอฮอล์ (เบียร์ ไวน์ และเครื่องดื่มสปิริต) จัดอยู่ในประเภทที่ 3 โดยมีอัตราภาษีร้อยละ 20 นอกจากนี้ ผลิตภัณฑ์เหล่านี้ยังมีค่าธรรมเนียมเพิ่มเติมที่แตกต่างกันระหว่าง 50 เปอร์เซ็นต์ 80 เปอร์เซ็นต์ และ 110 เปอร์เซ็นต์ ภาษีสำหรับเครื่องดื่มแอลกอฮอล์คิดตามลิตร (สุรา $1.4/ลิตร ไวน์ $0.47/ลิตร และเบียร์ $0.28/ลิตร)
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ขึ้นอยู่กับสินค้าแต่ละชนิด</span>
                    </div>
                </>
            )
        },
        'Saudi Arabia': {
            title: 'Saudi Arabia',
            flag: <span className='fi fi-sa'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Saudi Arabia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 266 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15% ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 266 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 39.90 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>266 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,136 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Saudi Arabia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 266 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15% ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 266 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 39.90 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>266 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,136 บาท</span>
                    </div>
                </>
            )
        },
        Senegal: {
            title: 'Senegal',
            flag: <span className='fi fi-sn'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Senegal</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 30 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>30 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>977 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Senegal</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 30 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>30 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>977 บาท</span>
                    </div>
                </>
            )
        },
        Serbia: {
            title: 'Serbia',
            flag: <span className='fi fi-rs'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Serbia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 50 ยูโร ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,847 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Serbia</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 50 ยูโร ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 20%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>50 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,847 บาท</span>
                    </div>
                </>
            )
        },
        Seychelles: {
            title: 'Seychelles',
            flag: <span className='fi fi-sc'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Seychelles</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Seychelles</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        'Sierra Leone': {
            title: 'Sierra Leone',
            flag: <span className='fi fi-sl'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Sierra Leone</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Sierra Leone</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Singapore: {
            title: 'Singapore',
            flag: <span className='fi fi-sg'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Singapore</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 สิงค์โปรดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,700 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Singapore</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 สิงค์โปรดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>9,700 บาท</span>
                    </div>
                </>
            )
        },
        'South Korea': {
            title: 'South Korea',
            flag: <span className='fi fi-kr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>South Korea</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>5,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>South Korea</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>5,000 บาท</span>
                    </div>
                </>
            )
        },
        Slovakia: {
            title: 'Slovakia',
            flag: <span className='fi fi-sk'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Slovakia</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Slovakia</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Slovenia: {
            title: 'Slovenia',
            flag: <span className='fi fi-si'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Slovenia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Slovenia</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        'Solomon Islands': {
            title: 'Solomon Islands',
            flag: <span className='fi fi-sb'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Solomon Islands</div>
                    <div className={classes.desc}>
                        มีอัตราภาษีนำเข้าตามมูลค่าสี่อัตราคือ 20, 15, 10 และ 5 % สำหรับสินค้านำเข้าส่วนใหญ่ อย่างไรก็ตาม ผู้นำเข้าบางรายได้รับการยกเว้นทั้งหมด รวมถึงรัฐบาลแห่งชาติและส่วนภูมิภาคของหมู่เกาะโซโลมอน
                    </div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 22% จากมูลค่าเต็มของสินค้าของตัวสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Solomon Islands</div>
                    <div className={classes.desc}>
                        มีอัตราภาษีนำเข้าตามมูลค่าสี่อัตราคือ 20, 15, 10 และ 5 % สำหรับสินค้านำเข้าส่วนใหญ่ อย่างไรก็ตาม ผู้นำเข้าบางรายได้รับการยกเว้นทั้งหมด รวมถึงรัฐบาลแห่งชาติและส่วนภูมิภาคของหมู่เกาะโซโลมอน
                    </div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 22% จากมูลค่าเต็มของสินค้าของตัวสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>15% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Somalia: {
            title: 'Somalia',
            flag: <span className='fi fi-so'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Somalia</div>
                    <div className={classes.desc}>
                        0% สินค้าเพื่อสังคมที่จำเป็น <br></br>
                        5% สินค้าจำเป็น วัตถุดิบ และปัจจัยการผลิตเฉพาะ <br></br>
                        10%สินค้าขั้นกลาง <br></br>
                        20% สินค้าอุปโภคบริโภคขั้นสุดท้าย <br></br>
                        35% สินค้าเฉพาะสำหรับการพัฒนาเศรษฐกิจ <br></br>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Somalia</div>
                    <div className={classes.desc}>
                        0% สินค้าเพื่อสังคมที่จำเป็น <br></br>
                        5% สินค้าจำเป็น วัตถุดิบ และปัจจัยการผลิตเฉพาะ <br></br>
                        10%สินค้าขั้นกลาง <br></br>
                        20% สินค้าอุปโภคบริโภคขั้นสุดท้าย <br></br>
                        35% สินค้าเฉพาะสำหรับการพัฒนาเศรษฐกิจ <br></br>
                    </div>
                </>
            )
        },
        'South Africa': {
            title: 'South Africa',
            flag: <span className='fi fi-za'></span>,
            content: trans(
                <>
                    <div className={classes.title}>South Africa</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 500 ZAR ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>500 ZAR</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>South Africa</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 500 ZAR ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>500 ZAR</span>
                    </div>
                </>
            )
        },
        'South Sudan': {
            title: 'South Sudan',
            flag: <span className='fi fi-ss'></span>,
            content: trans(
                <>
                    <div className={classes.title}>South Sudan</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>0 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>20% ของราคาทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>South Sudan</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>0 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>20% ของราคาทั้งหมด</span>
                    </div>
                </>
            )
        },
        Spain: {
            title: 'Spain',
            flag: <span className='fi fi-es'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Spain</div>
                    <div className={classes.example}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Spain</div>
                    <div className={classes.example}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        'Sri Lanka': {
            title: 'Sri Lanka',
            flag: <span className='fi fi-lk'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Sri Lanka</div>
                    <div className={classes.desc}>
                        อัตราภาษีนำเข้ามี 3 แถบ คือ วัตถุดิบจะอยู่ที่ 0 % สินค้าขั้นกลางอยู่ที่ 15 %และสินค้าสำเร็จรูปอยู่ที่ 30 % นอกจากนี้ สินค้าบางรายการ เช่น สินค้าเกษตรบางชนิด ต้องเสียภาษีตามปริมาณหรือภาษีเฉพาะ แล้วแต่จำนวนใดจะสูงกว่า
                    </div>
                </>,
                <>
                    <div className={classes.title}>Sri Lanka</div>
                    <div className={classes.desc}>
                        อัตราภาษีนำเข้ามี 3 แถบ คือ วัตถุดิบจะอยู่ที่ 0 % สินค้าขั้นกลางอยู่ที่ 15 %และสินค้าสำเร็จรูปอยู่ที่ 30 % นอกจากนี้ สินค้าบางรายการ เช่น สินค้าเกษตรบางชนิด ต้องเสียภาษีตามปริมาณหรือภาษีเฉพาะ แล้วแต่จำนวนใดจะสูงกว่า
                    </div>
                </>
            )
        },
        'Libya': {
            title: 'Libya',
            flag: <span className='fi fi-ly'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Libya</div>
                    <div className={classes.desc}>
                        <a style={{ color: '#009EFF' }} href="https://www.wto.org/english/res_e/statis_e/daily_update_e/tariff_profiles/LY_E.pdf" target='_blank'>รายละเอียด</a>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Libya</div>
                    <div className={classes.desc}>
                        <a style={{ color: '#009EFF' }} href="https://www.wto.org/english/res_e/statis_e/daily_update_e/tariff_profiles/LY_E.pdf" target='_blank'>รายละเอียด</a>
                    </div>
                </>
            )
        },
        Sudan: {
            title: 'Sudan',
            flag: <span className='fi fi-sd'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Sudan</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 CAD ภาษีนำเข้าสำหรับการขนส่งจะอยู่ที่ 5%
                    </div>
                    <div className={classes.example}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 CAD ภาษีนำเข้าสำหรับการขนส่งจะอยู่ที่ 5% ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 20 CAD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมอีก 1.00 CAD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 CAD</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Sudan</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 CAD ภาษีนำเข้าสำหรับการขนส่งจะอยู่ที่ 5%
                    </div>
                    <div className={classes.example}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 20 CAD ภาษีนำเข้าสำหรับการขนส่งจะอยู่ที่ 5% ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 20 CAD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมอีก 1.00 CAD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20 CAD</span>
                    </div>
                </>
            )
        },
        Suriname: {
            title: 'Suriname',
            flag: <span className='fi fi-sr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Suriname</div>
                    <div className={classes.desc}>
                        สินค้าเช่นน้ำผลไม้และเครื่องดื่มไม่มีแอลกอฮอล์จากประเทศสมาชิก CARICOM จะไม่ถูกเรียกเก็บภาษี 
                        วัตถุดิบจะถูกเรียกเก็บในอัตราร้อยละห้า 
                        อัตราภาษีสำหรับสินค้าเหล่านี้จากประเทศอื่นคือ 10 เปอร์เซ็นต์ 
                        สินค้ากึ่งสำเร็จรูปต้องเสียภาษีร้อยละ 10 
                        ภาษีสำหรับผลิตภัณฑ์สำเร็จรูปอยู่ระหว่างร้อยละ 15 ถึง 20 
                        สินค้าที่ต้องเสียภาษีสูงสุด (ร้อยละ 40 และ 50) ได้แก่ เครื่องดื่มแอลกอฮอล์ เบียร์ ยาสูบและบุหรี่ สัตว์มีชีวิต ปลา ไข่ น้ำผึ้ง ผัก ผลไม้ กาแฟ ธัญพืช หินมีค่าหรือกึ่งมีค่า และยานยนต์บางประเภท . ในปี 2560 
                        ภาษีศุลกากรสำหรับสัตว์ปีกได้เพิ่มขึ้นจากร้อยละ 20 เป็นร้อยละ 40 ซึ่งเป็นส่วนหนึ่งของนโยบายของรัฐบาลเพื่อให้อัตราภาษีท้องถิ่นสอดคล้องกับอัตรา CARICOM 
                        นอกจากภาษีแล้ว รัฐบาลยังเรียกเก็บค่าธรรมเนียมทางสถิติร้อยละ 0.5 ค่าธรรมเนียมการยินยอมร้อยละ 1.5 ของ C.I.F (ค่าประกันภัยและค่าขนส่ง) และภาษีการขายร้อยละ 10 มีการเรียกเก็บภาษีเพิ่มเติมสำหรับยาสูบและเครื่องดื่มแอลกอฮอล์ 
                    </div>
                </>,
                <>
                    <div className={classes.title}>Suriname</div>
                    <div className={classes.desc}>
                        สินค้าเช่นน้ำผลไม้และเครื่องดื่มไม่มีแอลกอฮอล์จากประเทศสมาชิก CARICOM จะไม่ถูกเรียกเก็บภาษี 
                        วัตถุดิบจะถูกเรียกเก็บในอัตราร้อยละห้า 
                        อัตราภาษีสำหรับสินค้าเหล่านี้จากประเทศอื่นคือ 10 เปอร์เซ็นต์ 
                        สินค้ากึ่งสำเร็จรูปต้องเสียภาษีร้อยละ 10 
                        ภาษีสำหรับผลิตภัณฑ์สำเร็จรูปอยู่ระหว่างร้อยละ 15 ถึง 20 
                        สินค้าที่ต้องเสียภาษีสูงสุด (ร้อยละ 40 และ 50) ได้แก่ เครื่องดื่มแอลกอฮอล์ เบียร์ ยาสูบและบุหรี่ สัตว์มีชีวิต ปลา ไข่ น้ำผึ้ง ผัก ผลไม้ กาแฟ ธัญพืช หินมีค่าหรือกึ่งมีค่า และยานยนต์บางประเภท . ในปี 2560 
                        ภาษีศุลกากรสำหรับสัตว์ปีกได้เพิ่มขึ้นจากร้อยละ 20 เป็นร้อยละ 40 ซึ่งเป็นส่วนหนึ่งของนโยบายของรัฐบาลเพื่อให้อัตราภาษีท้องถิ่นสอดคล้องกับอัตรา CARICOM 
                        นอกจากภาษีแล้ว รัฐบาลยังเรียกเก็บค่าธรรมเนียมทางสถิติร้อยละ 0.5 ค่าธรรมเนียมการยินยอมร้อยละ 1.5 ของ C.I.F (ค่าประกันภัยและค่าขนส่ง) และภาษีการขายร้อยละ 10 มีการเรียกเก็บภาษีเพิ่มเติมสำหรับยาสูบและเครื่องดื่มแอลกอฮอล์ 
                    </div>
                </>
            )
        },
        Sweden: {
            title: 'Sweden',
            flag: <span className='fi fi-se'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Sweden</div>
                    <div className={classes.example}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Sweden</div>
                    <div className={classes.example}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 22 ยูโร คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 22 ยูโร</span> คิดเป็นเงินไทย <span className={classes.highlight}>6,600 บาท</span>
                    </div>
                </>
            )
        },
        Switzerland: {
            title: 'Switzerland',
            flag: <span className='fi fi-ch'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Switzerland</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5 ฟรัง</span> คิดเป็นเงินไทย <span className={classes.highlight}>170 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Switzerland</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5 ฟรัง</span> คิดเป็นเงินไทย <span className={classes.highlight}>170 บาท</span>
                    </div>
                </>
            )
        },
        Tajikistan: {
            title: 'Tajikistan',
            flag: <span className='fi fi-tj'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Tajikistan</div>
                    <div className={classes.desc}>-</div>
                </>,
                <>
                    <div className={classes.title}>Tajikistan</div>
                    <div className={classes.desc}>-</div>
                </>
            )
        },
        Taiwan: {
            title: 'Taiwan',
            flag: <span className='fi fi-tw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Taiwan</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>3,000 ไต้หวั่นดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,300 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Taiwan</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>3,000 ไต้หวั่นดอลล่าร์</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,300 บาท</span>
                    </div>
                </>
            )
        },
        Tanzania: {
            title: 'Tanzania',
            flag: <span className='fi fi-tz'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Tanzania</div>
                    <div className={classes.desc}>
                        -
                    </div>
                </>,
                <>
                    <div className={classes.title}>Tanzania</div>
                    <div className={classes.desc}>
                        -
                    </div>
                </>
            )
        },
        Tonga: {
            title: 'Tonga',
            flag: <span className='fi fi-to'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Tonga</div>
                    <div className={classes.desc}>
                        -
                    </div>
                </>,
                <>
                    <div className={classes.title}>Tonga</div>
                    <div className={classes.desc}>
                        -
                    </div>
                </>
            )
        },
        'Trinidad and Tobago': {
            title: 'Trinidad and Tobago',
            flag: <span className='fi fi-tt'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Trinidad and Tobago</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 12.5% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12.5% จากราคาขนส่ง</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Trinidad and Tobago</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 12.5% จากมูลค่าเต็มของสินค้าของคุณ
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12.5% จากราคาขนส่ง</span>
                    </div>
                </>
            )
        },
        Turkey: {
            title: 'Turkey',
            flag: <span className='fi fi-tr'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Turkey</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 22 ยูโร ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 EUR</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Turkey</div>
                    <div className={classes.desc}>
                        หากมูลค่าเต็มของสินค้าของคุณมากกว่า 22 ยูโร ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 18%
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>22 EUR</span>
                    </div>
                </>
            )
        },
        Thailand: {
            title: 'Thailand',
            flag: <span className='fi fi-th'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Thailand</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 บาท</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,000 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Thailand</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000 บาท</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,000 บาท</span>
                    </div>
                </>
            )
        },
        Tuvalu: {
            title: 'Tuvalu',
            flag: <span className='fi fi-tv'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Tuvalu</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Tuvalu</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 20% จากมูลค่าเต็มของสินค้าของคุณ ตัวอย่างเช่น หากมูลค่าที่สำแดงของสินค้าของคุณคือ 100 USD เพื่อให้ผู้รับได้รับพัสดุ จะต้องชำระภาษีเพิ่มเติมจำนวน 20.00 USD ให้กับรัฐบาลของประเทศปลายทาง
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>20% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        'United Arab Emirates': {
            title: 'United Arab Emirates',
            flag: <span className='fi fi-ae'></span>,
            content: trans(
                <>
                    <div className={classes.title}>United Arab Emirates</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 5% จากมูลค่าเต็มของสินค้าของตัวสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>United Arab Emirates</div>
                    <div className={classes.example}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 5% จากมูลค่าเต็มของสินค้าของตัวสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Uganda: {
            title: 'Uganda',
            flag: <span className='fi fi-ug'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Uganda</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>330 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Uganda</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>330 บาท</span>
                    </div>
                </>
            )
        },
        Ukraine: {
            title: 'Ukraine',
            flag: <span className='fi fi-ug'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Ukraine</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Ukraine</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>
            )
        },
        'United Kingdom': {
            title: 'United Kingdom',
            flag: <span className='fi fi-gb'></span>,
            content: trans(
                <>
                    <div className={classes.title}>United Kingdom</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 15 ปอนด์ คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 15 ปอนด์</span> คิดเป็นเงินไทย <span className={classes.highlight}>5,800 + 650 = 6,450 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>United Kingdom</div>
                    <div className={classes.desc}>
                        ต้องชำระ 2 ส่วน 150 ยูโรคือ สิ่งของที่มูลค่าเกินจำนวนเงินดังกล่าว และ 15 ปอนด์ คือภาษีสินค้าทั่วไป
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>150 ยูโร และ 15 ปอนด์</span> คิดเป็นเงินไทย <span className={classes.highlight}>5,800 + 650 = 6,450 บาท</span>
                    </div>
                </>
            )
        },
        'United States of America': {
            title: 'United States of America',
            flag: <span className='fi fi-us'></span>,
            content: trans(
                <>
                    <div className={classes.title}>United States of America</div>
                    <div>ตั้งแต่วันที่ 29 สิงหาคม 2025 เป็นต้นไป</div>
                    <div>
                        สินค้าที่ส่งไปยังสหรัฐฯ ทุกมูลค่า จะต้องเสียภาษีและค่าธรรมเนียมศุลกากร <span className={classes.highlight}>ไม่มีการยกเว้น</span>สำหรับพัสดุที่มีมูลค่าต่ำกว่า <span className={classes.highlight}>800 ดอลล่าร์สหรัฐ</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>United States of America</div>
                    <div>ตั้งแต่วันที่ 29 สิงหาคม 2025 เป็นต้นไป</div>
                    <div>
                        สินค้าที่ส่งไปยังสหรัฐฯ ทุกมูลค่า จะต้องเสียภาษีและค่าธรรมเนียมศุลกากร <span className={classes.highlight}>ไม่มีการยกเว้น</span>สำหรับพัสดุที่มีมูลค่าต่ำกว่า <span className={classes.highlight}>800 ดอลล่าร์สหรัฐ</span>
                    </div>
                </>
            )
        },
        Uzbekistan: {
            title: 'Uzbekistan',
            flag: <span className='fi fi-uz'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Uzbekistan</div>
                    <div className={classes.desc}>
                        หากมูลค่าของสินค้ามากกว่า 400 USD จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>13,980 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Uzbekistan</div>
                    <div className={classes.desc}>
                        หากมูลค่าของสินค้ามากกว่า 400 USD จะเสียภาษี 20%ของมูลค่าทั้งหมด
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>400 USD</span> คิดเป็นเงินไทย <span className={classes.highlight}>13,980 บาท</span>
                    </div>
                </>
            )
        },
        Venezuela: {
            title: 'Venezuela',
            flag: <span className='fi fi-ve'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Venezuela</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Venezuela</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>100 ดอลล่าร์สหรัฐ</span> คิดเป็นเงินไทย <span className={classes.highlight}>3,400 บาท</span>
                    </div>
                </>
            )
        },
        Vanuatu: {
            title: 'Vanuatu',
            flag: <span className='fi fi-vu'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Vanuatu</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12.5% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Vanuatu</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>12.5% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Vatican: {
            title: 'Vatican',
            flag: <span className='fi fi-va'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Vatican</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Vatican</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>ไม่มี</span>
                    </div>
                </>
            )
        },
        Yemen: {
            title: 'Yemen',
            flag: <span className='fi fi-ye'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Yemen</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 5% จากมูลค่าเต็มของสินค้าของตัวสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5% ของมูลค่าทั้งหมด</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Yemen</div>
                    <div className={classes.desc}>
                        ภาษีนำเข้าที่เรียกเก็บจากการขนส่งจะอยู่ที่ 5% จากมูลค่าเต็มของสินค้าของตัวสินค้า
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>5% ของมูลค่าทั้งหมด</span>
                    </div>
                </>
            )
        },
        Zimbabwe: {
            title: 'Zimbabwe',
            flag: <span className='fi fi-zw'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Zimbabwe</div>
                    <div className={classes.desc}>
                        มูลค่าเต็มของสินค้าของคุณมากกว่า 10 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15% 
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 USD</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Zimbabwe</div>
                    <div className={classes.desc}>
                        มูลค่าเต็มของสินค้าของคุณมากกว่า 10 USD ภาษีนำเข้าสำหรับการจัดส่งจะอยู่ที่ 15% 
                    </div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>10 USD</span>
                    </div>
                </>
            )
        },
        Zambia: {
            title: 'Zambia',
            flag: <span className='fi fi-zm'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Zambia</div>
                    <div className={classes.desc}>
                        0% เครื่องจักรที่มีประสิทธิภาพสำหรับการเกษตร พลังงานแสงอาทิตย์ การเพาะเลี้ยงสัตว์น้ำ และการขุด <br></br>
                        0 - 5% อุปกรณ์ทุนและวัตถุดิบ <br></br>
                        15% สินค้าขั้นกลาง <br></br>
                        25% สินค้าสำเร็จรูป <br></br>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Zambia</div>
                    <div className={classes.desc}>
                        0% เครื่องจักรที่มีประสิทธิภาพสำหรับการเกษตร พลังงานแสงอาทิตย์ การเพาะเลี้ยงสัตว์น้ำ และการขุด <br></br>
                        0 - 5% อุปกรณ์ทุนและวัตถุดิบ <br></br>
                        15% สินค้าขั้นกลาง <br></br>
                        25% สินค้าสำเร็จรูป <br></br>
                    </div>
                </>
            )
        },
        Vietnam: {
            title: 'Vietnam',
            flag: <span className='fi fi-vn'></span>,
            content: trans(
                <>
                    <div className={classes.title}>Vietnam</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000,000 ดง</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,500 บาท</span>
                    </div>
                </>,
                <>
                    <div className={classes.title}>Vietnam</div>
                    <div>
                        มูลค่าที่ไม่ต้องเสียภาษี <span className={classes.highlight}>1,000,000 ดง</span> คิดเป็นเงินไทย <span className={classes.highlight}>1,500 บาท</span>
                    </div>
                </>
            )
        },
    }
}

export default getDeMinimisData
